import React, {PropsWithChildren} from 'react';
import {Icon} from '@iconify/react';

import './prompt.scss';

export interface PromptProps {
    label: string;
    type: 'info' | 'warning' | 'error';
    className?: string;
}

const iconMap: Record<'info' | 'warning' | 'error', string> = {
    info: 'solar:question-square-bold',
    warning: 'solar:danger-triangle-bold',
    error: 'solar:danger-circle-bold',
};

function Prompt(props: PropsWithChildren<PromptProps>): JSX.Element {
    const {label, type, className} = props;

    return (
        <div className={`c-prompt ${className} c-prompt--${type}`}>
            <Icon className={`c-prompt__icon c-prompt__icon--${type}`} icon={iconMap[type]} />
            <div className="c-prompt__label">{label}</div>
        </div>
    );
}

export default Prompt;
